import { LayoutDefault } from '@/layout';
import { RouteConfig } from 'vue-router';

import adminRouting from '@/app/admin/admin.routing';
import attendanceRouting from '@/app/attendance/attendance.routing';
import AppManageRouting from '@/app/appmanage/appmanage.routing';
import commonbllRouting from '@/app/commonbll/commonbll.routing';
import CustomizeReportRouting from '@/app/customizereport/customizereport.routing';
import KanBanRouting from '@/app/kanban/kanban.routing';
import mainRouting from '@/app/main/main.routing';
import MessageManageRouting from '@/app/message-manage/message-manage.routing';
import OARouting from '@/app/oa/oa.routing';
import organizationRouting from '@/app/organization/organization.routing';
import processappRouting from '@/app/processapp/processapp.routing';
import ReportRouting from '@/app/report/report.routing';
import SystemAdminIstrationRouting from '@/app/systemadministration/systemadministration.routing';
import TaskSystemRouting from '@/app/task-system/task-system.routing';
import UnderlyingRouting from '@/app/underlying-data/underlying.routing';

const appRouting: RouteConfig[] = [
    {
        path: '/app',
        component: LayoutDefault,
        redirect: '/app/main',
        children: [
            ...mainRouting,
            ...adminRouting,
            ...attendanceRouting,
            ...commonbllRouting,
            ...processappRouting,
            ...AppManageRouting,
            ...OARouting,
            ...organizationRouting,
            ...CustomizeReportRouting,
            ...MessageManageRouting,
            ...TaskSystemRouting,
            ...UnderlyingRouting,
            ...SystemAdminIstrationRouting,
            ...ReportRouting,
            ...KanBanRouting,
        ],
    },
];

export default appRouting;
